<template>
    <div class="table-responsive">
        <table class="table table-list">
            <thead>
            <tr>
                <th v-for="thead in Thead">{{thead}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(index,tbody) in Table">
                <td v-for="td in tbody">{{td}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>


<script>
    export default {
        props : ["Thead","Table"]
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Pack/Table.vue